<template>
  <div class="payment-method-list-warning">
    <div class="payment-method-list-warning__wrapper">
      <AlertCircleIcon
        class="payment-method-list-warning__icon"
        color="#EF7D22"
        size="24"
      />
      <p class="payment-method-list-warning__text">
        Replacing your payment method will also update your recurring
        subscription payment method. Are you sure you want to continue?
      </p>
    </div>
    <button v-if="showContinueBtn" @click="$emit('handle-continue')" class="btn btn--secondary">
      Continue
    </button>
  </div>
</template>

<script>
import { AlertCircleIcon } from 'vue-feather-icons'

export default {
  name: 'PaymentMethodListWarning',
  emits: ['handle-continue'],
  components: {
    AlertCircleIcon,
  },
  props: {
    showContinueBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-method-list-warning {
  font-size: rem(14px);
  font-style: normal;
  font-weight: 450;
  line-height: rem(20px);
  display: flex;
  align-items: center;
  &__wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  &__text {
    text-align: left;
    margin: 0;
    width: 80%;
  }
  &__cta {
  }
}
</style>
